import React, { useEffect } from 'react'
import ApproverRegister from './ApproverRegister'

const ClerkRegister = (props) => {
useEffect(()=>
{
  console.log("clerkfile")
    const nextapicall=async ()=>
{
  
  let pesponse = await fetch(
    `http://localhost:8080/auth/admin/realms/forms-flow-ai/users`,
    {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      // credentials: 'same-origin', // include, *same-origin, omit
      headers: {
          'Content-Type': 'application/json',
           "Host": "localhost:8080",
           'Content-Length': JSON.stringify({
            enabled: true,
            attributes: {},
            groups: ["/formsflow/formsflow-reviewer/clerk"],
            username: props.submissiondata.data.clerkname,
            emailVerified: "",
            credentials: [{
              type: "password",
              value: "changeme",
                temporary: "true"
            }],
            email: props.submissiondata.data.clerkname,
          }).length,

          Authorization: process.env.REACT_APP_KEYCLOAK_MASTERREALM_TOKEN,
        

        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body:JSON.stringify({
        enabled: true,
        attributes: {},
        groups: ["/formsflow/formsflow-reviewer/clerk"],
        username: props.submissiondata.data.clerkemail,
        emailVerified: "",
        credentials: [{
          type: "password",
          value: "changeme",
            temporary: "true"
        }],
        email: props.submissiondata.data.clerkemail,
      }) // body data type must match "Content-Type" header
    }
  )
}

nextapicall();
},[])


  return (
    <ApproverRegister submissiondata={props.submissiondata}/>
  )
}

export default ClerkRegister